import moment from 'moment';
import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  DATE_YEAR_FORMAT,
} from '../../constants';

export function toDateFormat(dateString: string): string {
  return moment(dateString).format(DATE_TIME_FORMAT);
}

export const chartDateFormatter = (
  value: Date | string | number,
  format = DATE_FORMAT,
) => moment(value as Date).format(format);

export const chartDateFormatterWithYears = (
  value: Date | string | number,
  isManyYears = false,
) => chartDateFormatter(value, isManyYears ? DATE_YEAR_FORMAT : DATE_FORMAT);
